<template>
  <hr />
</template>
<script>
export default {};
</script>

<style scoped lang='scss'>
div {
  hr {
    width: 50px;
    height: 1px;
    background: #222323;
    display: inline-block;
    margin: 20px 0;
  }
}
</style>
